import "./style/index.scss";
import Flex from "./Flex";
import FlexItem from "./FlexItem";
var ExportFlex = Flex;
ExportFlex.Item = FlexItem;
export { ExportFlex as Flex };